import styled, { css } from 'styled-components';
import { palette, key } from 'styled-theme';

import { media } from '../../../helper/styleHelper';

const fontSettings = {
  small: {
    size: key('sizes.font.tiny', '9px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.font.small', '10px'),
    spacing: '0.3px',
  },
  big: {
    size: key('sizes.font.normal', '16px'),
    spacing: '0px',
  },
};

const xlrFontSettings = {
  small: {
    size: key('sizes.xlrFont.tiny', '12px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.xlrFont.normal', '14px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.xlrFont.normal', '16px'),
    spacing: '0px',
  },
};

const xxlFontSettings = {
  small: {
    size: key('sizes.xxlFont.tiny', '11px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.xxlFont.normal', '16px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.xxlFont.normal', '16px'),
    spacing: '0px',
  },
};

const vxxlFontSettings = {
  small: {
    size: key('sizes.vxxlFont.tiny', '14px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.vxxlFont.small', '16px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.vxxlFont.normal', '16px'),
    spacing: '0px',
  },
};

const sizes = {
  small: '30px',
  normal: '40px',
  big: '40px',
};

const xlrSizes = {
  small: '40px',
  normal: '40px',
  big: '40px',
};

const xxlSizes = {
  small: '40px',
  normal: '50px',
  big: '60px',
};

const vxxlSizes = {
  small: '40px',
  normal: '50px',
  big: '60px',
};

const colors = {
  primary: palette('active', 0),
  success: palette('success', 0),
  warning: palette('warning', 0),
  error: '#FA8072',
};

export const StyledInputField = styled.input`
  outline: none;
  box-sizing: border-box;
  font-family: Space Grotesk Regular;
  padding: 11px 10px;
  border: none;
  position: relative;
  background-color: transparent;
  height: ${(props) => sizes[props.sizevalue]};
  ${(props) => css`
    height: ${sizes[props.sizevalue]};
    font-size: ${fontSettings[props.sizevalue].size};
    letter-spacing: ${fontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.sm`
    height: ${sizes[props.sizevalue]};
    padding: 11px 10px;
  `}

  ${(props) => media.xlr`
  height: ${xlrSizes[props.sizevalue]};
  font-size: ${xlrFontSettings[props.sizevalue].size};
  letter-spacing: ${xlrFontSettings[props.sizevalue].spacing};
  padding: 11px 10px;
  `}

  ${(props) => media.xxl`
  height: ${xxlSizes[props.sizevalue]};
  font-size: ${xxlFontSettings[props.sizevalue].size};
  letter-spacing: ${xxlFontSettings[props.sizevalue].spacing};
  /* padding: ${key('sizes.gutter.small', '30px')} ${key('sizes.gutter.normal', '40px')}; */
  `}

  ${(props) => media.vxxl`
  height: ${vxxlSizes[props.sizevalue]};
  font-size: ${vxxlFontSettings[props.sizevalue].size};
  letter-spacing: ${vxxlFontSettings[props.sizevalue].spacing};
  /* padding: ${key('sizes.gutter.small', '30px')} ${key('sizes.gutter.normal', '40px')}; */
  `}
  
  width: 100%;

  border-bottom: 1px solid ${palette('gray', 3)};
  color: ${palette('text', 1)};
  ${(props) => props.varient === 'ghost' && 'border: none;'};
  ${(props) => props.varient === 'ghost' && 'background: #F0F3F7;'};

  ${({ error }) =>
    error
      ? css`
          border-color: ${colors['error']};
        `
      : css`
          &:hover,
          &:focus {
            border-color: ${(props) => colors[props.color]};
            box-shadow: ${(props) =>
              props.varient === 'ghost' ? 'none' : '0 0 0 2px ' + colors[props.color]};
          }
        `}

  &::placeholder {
    font-size: ${fontSettings['big'].size};
    ${({ error }) =>
      error
        ? css`
            color: ${palette('error', 0)};
          `
        : css`
            color: ${palette('text', 5)};
            opacity: 0.35;
          `}
    ${media.xxl`
    font-size: ${xxlFontSettings['big'].size};
    `}
    ${media.vxxl`
    font-size: ${vxxlFontSettings['big'].size};
    `}
  }

  ${({ readOnly }) =>
    readOnly &&
    css`
      background: #e8e8eb;
    `}

  ${({ disabled, isNotAllow }) =>
    disabled &&
    !isNotAllow &&
    css`
      color: grey;
      &:hover,
      &:focus {
        border-color: #e8e8eb;
        box-shadow: #e8e8eb;
      }
      cursor: not-allowed;
    `}

  ${(props) =>
    props.color === 'error' &&
    css`
      border-color: ${colors[props.color]};
    `}
`;
